/**
 * @fileoverview GET handler for the "/engagement/content_block_locales" endpoint
 */

import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementContentBlockLocales } from "./constants";
import type { EngagementContentBlockLocalesResponse, EngagementContentBlockLocalesParams } from "./types";

export const getEngagementContentBlockLocales = reactQueryFetcherAdapter(
  engagementContentBlockLocales,
  (
    signal: AbortSignal,
    params: EngagementContentBlockLocalesParams
  ): Promise<EngagementContentBlockLocalesResponse> => {
    return fetch(
      "/engagement/content_block_locales",
      "GET",
      {
        content_block_names: params.contentBlockNames,
        start: params.start ?? 0,
        limit: params.limit ?? 25,
      },
      { signal }
    );
  }
);
